import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='additionalInfo' subtitle='PrimerCheckoutAdditionalInfo' mdxType="Item">
	<Group summary='direct subclasses' open mdxType="Group">
		<Item title='XenditCheckoutVoucherAdditionalInfo' mdxType="Item">
			<Group summary='parameters' open mdxType="Group">
				<Item title='expiresAt' subtitle='String' label='Required' mdxType="Item" />
				<Item title='couponCode' subtitle='String' label='Required' mdxType="Item" />
				<Item title='retailerName' subtitle='String' label='Required' mdxType="Item" />
			</Group>
		</Item>
		<Item title='PromptPayCheckoutAdditionalInfo' mdxType="Item">
			<Group summary='parameters' open mdxType="Group">
				<Item title='expiresAt' subtitle='String' label='Required' mdxType="Item" />
				<Item title='qrCodeUrl' subtitle='String' mdxType="Item" />
				<Item title='qrCodeBase64' subtitle='String' label='Required' mdxType="Item" />
			</Group>
		</Item>
		<Item title='MultibancoCheckoutAdditionalInfo' mdxType="Item">
			<Group summary='parameters' open mdxType="Group">
				<Item title='expiresAt' subtitle='String' mdxType="Item" />
				<Item title='entity' subtitle='String' mdxType="Item" />
				<Item title='reference' subtitle='String' mdxType="Item" />
			</Group>
		</Item>
		<Item title='ACHAdditionalInfo' mdxType="Item">
			<Group summary='Subclasses' open mdxType="Group">
				<Item title='ACHBankAccountCollectorAdditionalInfo' subtitle='ACHAdditionalInfo' mdxType="Item">
					<Group summary='Properties' open mdxType="Group">
						<Item title='collectorViewController' subtitle='UIViewController' mdxType="Item">
						Provides the bank account collector for ACH bank account selection.
						</Item>
					</Group>
				</Item>
				<Item title='ACHMandateAdditionalInfo' subtitle='ACHAdditionalInfo' mdxType="Item">
				<p>Provides an empty <code>ACHMandateAdditionalInfo</code> object to prompt the merchant to display the mandate information.</p>
				</Item>
			</Group>
		</Item>
	</Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      